import { Box, Stack, useTheme } from "@mui/material";
import { UndoRedoButtons } from "./undo-redo-buttons";

import type { ToolbarProps } from "./props";
import type { FC, ReactNode } from "react";

type Props = ToolbarProps & {
  rightAlignedElements: ReactNode;
  children: ReactNode;
};

export const ToolbarV2: FC<Props> = ({
  disabled,
  children,
  rightAlignedElements,
  stickyTop = 70,
}) => {
  const theme = useTheme();

  return (
    <Box
      id="toolbar-container"
      sx={{
        position: "sticky",
        top: stickyTop,
        zIndex: 1000,
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        borderBottom: 1,
        borderBottomStyle: "solid",
        borderBottomColor: "divider",
        px: 2,
        py: 0.5,
        transition: theme.transitions.create(["padding-left"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.05)",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap">
          {children}
        </Stack>

        <Stack direction="row" alignItems="center" spacing={1}>
          <Stack direction="row" alignItems="center" spacing={1}>
            {rightAlignedElements}
            <UndoRedoButtons disabled={disabled} />
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};
